import qs from 'qs'
import { axios } from '@/utils/request'

//专家信息统计相关Api
const expertStatisticsApi = {
  getExpertStatistic: '/api/v1/expert/statistic/getExpertStatistic',
}

//抽取专家统计相关Api
const extractStatisticsApi = {
  getExtractStatistic: '/api/v1/extract/statistic/getExtractStatistic',
}

/**
 * 获取专家信息统计信息
 * @returns {AxiosPromise<any>}
 */
export const GetExpertStatistic = () => axios.get(expertStatisticsApi.getExpertStatistic, {})
/**
 * 获取抽取信息统计信息
 * @returns {AxiosPromise<any>}
 */
export const GetExtractStatistic = (params) => axios.get(extractStatisticsApi.getExtractStatistic, { params: params })
